export default { 

  UI_SET_KEY : 'ui.setKey',
  UI_MULTI_SET_KEY : 'ui.multiSetKey',

  FORM_SET_KEY : 'form.setKey',
  FORM_MULTI_SET_KEY : 'form.multiSetKey',

  SELECT_ADD : 'select.add',
  SELECT_SET : 'select.set',
  SELECT_REMOVE : 'select.remove',
  SELECT_TOGGLE : 'select.toggle',
  SELECT_CLEAR : 'select.clear',
  SELECT_CLEAR_ALL : 'select.clear.all',

  SELECTION_CONFIG : 'selection.config',
  SELECTION_ADD : 'selection.add',
  SELECTION_SET : 'selection.set',
  SELECTION_REMOVE : 'selection.remove',
  SELECTION_TOGGLE : 'selection.toggle',
  SELECTION_CLEAR : 'selection.clear',
  SELECTION_CLEAR_ALL : 'selection.clear.all',
  SELECTION_POP : 'selection.pop',

  FILTER_ADD : 'filter.add',
  FILTER_REMOVE : 'filter.remove',
  FILTER_SET : 'filter.set',
  FILTER_CLEAR : 'filter.clear',
  FILTER_CLEAR_ALL : 'filter.clear.all',

  SORT_SET : 'sort.set',
  SORT_TOGGLE : 'sort.toggle',
  SORT_REMOVE : 'sort.remove',
  SORT_CLEAR : 'sort.clear',
  SORT_CLEAR_ALL : 'sort.clear.all'
} 
